import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import RootStoreContext from '~/contexts/RootStoreContext';
import {
  actions as commonActions,
  selectors as commonSelectors
} from '~/domains/common';
import {
  actions as modalActions,
  selectors as modalSelectors
} from '~/domains/modal';
import { selectors as agentScannersSelectors } from '~/domains/agentScanners';
import withLayoutContext from '~/components/LayoutContextProvider';
import { setModalType, registerModal } from '~/components/Modals';
import { getActiveOrganizationId } from '~/utils/organization';
import ReviewFixModal from './ReviewFixModal';

const mapStateToProps = (state) => {
  const profile = commonSelectors.profile(state);
  const modalProps = modalSelectors.modalProps(state);

  return {
    profile,
    organizationId: getActiveOrganizationId(profile),
    failedScanners: modalProps?.failedScanners || [],
    scanners: agentScannersSelectors.scanners(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  // eslint-disable-next-line global-require -- lazy require breaks circular import cycle between ReviewFixModal and agentScanners domain
  const { actions: agentScannersActions } = require('~/domains/agentScanners');

  return {
    onCancel: () => dispatch(modalActions.closeModal()),
    onRetryScan: (scanner, organizationId) =>
      dispatch(
        agentScannersActions.runScanConfiguration(organizationId, scanner.id)
      )
        .then(() => {
          dispatch(agentScannersActions.loadAgentScanners(organizationId));
        })
        .catch(() => {
          dispatch(
            commonActions.setAlert({
              type: 'error',
              message: `Failed to retry scan for '${scanner?.name || 'Unknown'}'. Please try again.`,
              isHTML: false
            })
          );
        }),
    loadScanners: (organizationId) =>
      dispatch(agentScannersActions.loadAgentScanners(organizationId))
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  onCancel: dispatchProps.onCancel,
  onRetryScan: (scanner) =>
    dispatchProps.onRetryScan(scanner, stateProps.organizationId),
  loadScanners: () => dispatchProps.loadScanners(stateProps.organizationId)
});

export default compose(
  registerModal,
  setModalType('ReviewFixModal'),
  withLayoutContext(),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps, mergeProps, {
    context: RootStoreContext
  })
)(ReviewFixModal);
